import React from 'react'
import { useQuery } from '@apollo/client'

export function usePaginatedQuery(
  query,
  { variables = {}, initialPageSize = 10, initialPageIndex = 0 } = {}
) {
  const [pageSize, setPageSize] = React.useState(initialPageSize)
  const [pageIndex, setPageIndex] = React.useState(initialPageIndex)

  const { fetchMore, ...apollo } = useQuery(query, {
    variables: {
      ...variables,
      offset: pageIndex * pageSize,
      max: pageSize
    }
  })

  const fetchPage = React.useCallback(
    async newPageIndex => {
      await fetchMore({
        variables: {
          offset: newPageIndex * pageSize
        }
      })
      setPageIndex(newPageIndex)
    },
    [pageSize, fetchMore]
  )

  return {
    ...apollo,
    pageSize,
    pageIndex,
    fetchPage,
    setPageSize
  }
}
